export const renderNumberOfTimes = (num) => {
  let times = [];
  for (let i = 1; i <= num; i++) {
    times.push(i);
  }
  return times;
};

export const conditionalList = (list, condition) => {
  return list.filter((item) => {
    return item.conditional === condition || item.conditional === '';
  });
};

export function shuffle(array) {
  let currentIndex = array.length;
  let temporaryValue;
  let randomIndex;
  let newArray = [...array];

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = newArray[currentIndex];
    newArray[currentIndex] = newArray[randomIndex];
    newArray[randomIndex] = temporaryValue;
  }

  return newArray;
}

export const sortObjects = (objs, item, order = 'asc') => {
  if (order === 'asc')
    return objs.sort((a, b) => (a[item] > b[item] ? +1 : b[item] > a[item] ? -1 : 0));
  return objs.sort((a, b) => (a[item] > b[item] ? -1 : b[item] > a[item] ? +1 : 0));
};

export const sortArray = (arr, order = 'asc') => {
  if (order === 'asc') return arr.sort((a, b) => (a > b ? +1 : b > a ? -1 : 0));
  return arr.sort((a, b) => (a > b ? -1 : b > a ? +1 : 0));
};

export const uniqueElements2Arrays = (array1, array2) =>
  array1.filter(function (obj) {
    return array2.indexOf(obj) === -1;
  });

export const changeArrayLine = (line, allArrays, set_allArrays, id = 'id') => {
  let modArrays = allArrays.map((Array) => {
    if (parseInt(Array[id]) === parseInt(line[id])) return { ...Array, ...line };
    return Array;
  });
  set_allArrays(modArrays);
};
